export const useLocalStorage = {
    get(key, defaultValue) {
        try {
            const item = localStorage.getItem(key)
            return item ? JSON.parse(item) : defaultValue
        } catch (error) {
            return defaultValue
        }
    },
    set(key, value) {
        try {
            if (value === null || value === undefined) {
                localStorage.removeItem(key)
                return
            }
            localStorage.setItem(key, JSON.stringify(value))
        } catch (error) {
            // Ignore storage failures, e.g. private mode quota or unavailable storage.
        }
    }
}
